import React from 'react';

import { Tooltip } from 'primereact/tooltip';

interface DropdownWithDeletedValueTemplateProps {
  option: any;
  selectedItem: { label?: string } | null | undefined;
  placeholder?: string;
  showDeletedIcon?: boolean;
  tooltipText?: string;
}

export const DropdownWithDeletedValueTemplate: React.FC<DropdownWithDeletedValueTemplateProps> = ({
  option,
  selectedItem,
  placeholder = 'Выберите значение',
  showDeletedIcon = true,
  tooltipText = 'Удалено в справочнике'
}) => {
  if (!selectedItem) {
    return <span className="p-placeholder">{placeholder}</span>;
  }

  return (
    <div className="flex align-items-center gap-2">
      {selectedItem?.label}
      {(!option && selectedItem && showDeletedIcon) && (
        <>
          <i 
            className="pi pi-exclamation-circle text-red-200 deleted-status-tooltip"
            data-pr-tooltip={tooltipText} 
          />
          <Tooltip target=".deleted-status-tooltip" />
        </>
      )}
    </div>
  );
};